module.exports = __webpack_public_path__ + "media/images/category/dummy/bag03-6ef71f73380b3ad922aa8afd13f60838.jpg";